import { useState as l, useRef as s, useEffect as u } from "react";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { _ as z } from "./getTarget-19e0f923.js";
import { i as O } from "./isApiSupported-66660265.js";
import { i as a } from "./isClient-2f5bedbd.js";
import { useIsMounted as w } from "./useIsMounted.js";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
var Z = function(r, e) {
  r === void 0 && (r = a ? window.document.body : void 0);
  var m = l({}), v = m[0], f = m[1], c = w(), t = s(e), d = s(a && O("ResizeObserver"));
  return u(function() {
    t.current = e;
  }, [e]), u(function() {
    if (d.current) {
      var i = z(r);
      if (i) {
        var p = function(n, b) {
          window.requestAnimationFrame(function() {
            f(n[0]), t.current == null || t.current(n, b);
          });
        }, o = new ResizeObserver(p);
        return o.observe(i), p([{
          target: i
        }], o), function() {
          return o.disconnect();
        };
      }
    }
  }, [r, c]), v;
};
export {
  Z as useResizeObserver
};
